import React from "react";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import { Loading } from "app/components/Wrappers";

interface Props {
  isLoading?: boolean;
  loaderChild?: React.ReactNode;
  loadingClassname?: string;
  displayNoResult?: boolean;
  noResultChild?: React.ReactNode;
  children: React.ReactNode;
}

const SegmentsLayout = ({
  isLoading,
  loaderChild,
  children,
  displayNoResult,
  noResultChild,
}: Props) => {
  return (
    <div className={styles.container}>
      <GettingStartedProgress />
      {isLoading &&
        (loaderChild ? (
          loaderChild
        ) : (
          <Loading isLoading={isLoading} loadType="spinner" data-testid='templates_loader' />
        ))}
      {displayNoResult && !isLoading && <>{noResultChild}</>}
      {!displayNoResult && !isLoading && <>{children}</>}
    </div>
  );
};

export default SegmentsLayout;
